import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import Services from './pages/Services';
import Profile from './pages/Profile';
import Playdates from './pages/Playdates';
import PetSearch from './pages/PetSearch';

function App() {
  return (
    <ThemeProvider>
      <Router basename="/Pawfect-Match">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/services" element={<Services />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/playdates" element={<Playdates />} />
            <Route path="/search" element={<PetSearch />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
